import React from 'react';
import { Row, Col, Button, Dropdown, Menu, Modal } from 'antd';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import API from '@/api'
import Tree from './Tree'
import BookModel from './BookModel'
import CategoryModel from './CategoryModel'
import './index.less'
import xmlToJson from '@/lib/xmlToJson'
import moment from 'moment'

class Book extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      treeList: [],
      bookData: [],
      checkedList: [],
      html: '',
      loading: false
    }
  }

  async refreshTree () {
    const treeRes = await API.GetCategory()
    if (treeRes.code !== 200) return

    const bookDataRes = await API.GetBook()
    if (bookDataRes.code !== 200) return

    this.setState({
      treeList: treeRes.result,
      bookData: bookDataRes.result
    })
  }

  async componentDidMount () {
    this.refreshTree()
  }

  onCheck = async (checkedList, info) => {
    this.setState({
      checkedList: info.checkedNodes
    })
  }

  del = () => {
    console.log('this.state.checkedList', this.state.checkedList)
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      maskClosable: true,
      content: (
        <div>
          确定删除
          {
            this.state.checkedList.map(item => {
              return (
                <span key={item.key} style={{ margin: '0 4px', color: 'gold' }}>
                  {item.text_title}
                </span>
              )
            })
          }
        </div>
      ),
      okText: '确认',
      cancelText: '取消',
      onCancel() {
        console.log('1233')
      },
      onOk: async () => {
        const { checkedList } = this.state
        const category_id_arr = []
        const book_id_arr = []

        checkedList.forEach(item => {
          item.type === 'category' ? category_id_arr.push(item.key) : book_id_arr.push(item.key)
        })

        const delRes = await API.DelBook({
          category_id_arr: category_id_arr.length ? category_id_arr : undefined,
          book_id_arr: book_id_arr.length ? book_id_arr : undefined
        })
        if (delRes.code !== 200) return
        this.setState({
          checkedList: []
        })
        this.refreshTree()
      }
    })
  }

  async importFile () {
    document.querySelector('#demo').click()
  }

  async onGetFile (e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    // 用readAsText读取TXT文件内容
    reader.readAsText(file);
    reader.onload = async (e) => {
      // console.log(e.target.result); 　　 //读取结果保存在字符串中
      let my_str = e.target.result;　　　　//直接保存全部数据为一个字符串
      let my_arr = my_str.split(/[\s\n]/); 　　//按空格和换行符切割字符串，并保存在数组中

      // console.log(xmlToJson(e.target.result), my_arr)



      // const vdom = (
      //   <div dangerouslySetInnerHTML={{__html: e.target.result}} ></div>
      // )
      // // console.log('pppp', pp)

      // console.log( JSON.stringify( vdom , null , 2) )


      this.setState({
        html: e.target.result
        // previewPic: e.target.result,
        // arr : my_arr
      });
      // setTimeout(() => {
        // console.log('html', this.refs.html)
        // console.log('html', this.parseElement(this.refs.html))
        // console.log('html', this.parseElement(this.state.html))
  
        const ff = this.fun(this.parseElement(this.state.html))
        console.log('ff', ff)
        this.setState({ loading: true })
        await this.sync(ff)
        this.setState({ loading: false })
        this.refreshTree()
      // }, 1000)
    }
  }

  async sync (obj, categoryId = undefined) {
    if (!obj.url) {
      console.log('obj', obj)
      const res = await API.SaveCategory({
        category_id: categoryId,
        title: obj.title,
        add_date: moment(Number(obj.add_date)).format(),
        last_modified: moment(Number(obj.last_modified)).format(),
      })
      if (res.code === 200) {
        if (obj.child) {
          for (let i = 0; i < obj.child.length; i++) {
            await this.sync(obj.child[i], res.result.id)
          }
        }
      }
    } else {
      await API.SaveBook({
        category_id: categoryId,
        title: obj.title,
        add_date: moment(Number(obj.add_date)).format(),
        url: obj.url,
        icon: obj.icon || undefined
      })
    }
  }

  
  fun (dom) {
    const childNodesFirst = dom.childNodes[0]
    const obj = {}
    const title = childNodesFirst.childNodes[0] ? childNodesFirst.childNodes[0].data : ''
    const arr = []
    const child = []

    if (dom.childNodes[2]) {
      dom.childNodes[2].childNodes.forEach((item, index) => {
        if (index !== 0) arr.push(item)
      })
    }

    for (let i = 0; i < arr.length; i++) {
      const ci = arr[i]
      child.push(this.fun(ci))
    }

    obj.title = title
    obj.add_date = childNodesFirst.attributes.add_date.value
    if (childNodesFirst.href) {
      obj.url = childNodesFirst.href
      if (childNodesFirst.attributes.icon) {
        obj.icon = childNodesFirst.attributes.icon.value
      }
    } else {
      obj.last_modified = childNodesFirst.attributes.last_modified.value
      obj.child = child
    }

    return obj
  }

  parseElement (htmlString) {
    return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[2].childNodes[1]
    // return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[2].childNodes[1].childNodes[2].childNodes[1].childNodes[0].childNodes[0].data
    // return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[2].childNodes[1].childNodes[2].childNodes[1].childNodes[2].childNodes
    // return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[2].childNodes[1].childNodes[0].childNodes[0].data
    // return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[2].childNodes[1].childNodes[2].childNodes
  }

  render () {
    const { onCheck, state, del } = this
    const { treeList, bookData, checkedList, html, loading } = state

    const menu = (
      <Menu>
        <Menu.Item danger onClick={() => del()}>
          删除
        </Menu.Item>
      </Menu>
    )

    return (
      <div className="page-book">
        {/* <div dangerouslySetInnerHTML={{__html: html}} ref="html"></div> */}
        <input type="file" onChange={e => this.onGetFile(e)} id="demo" hidden={true} />
        <Row gutter={16}>
          {
            checkedList.length > 0 && (
              <Col span={4}>
                <Dropdown overlay={menu}>
                  <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <Button
                      type="default"
                      style={{ width: '100%' }}
                      onClick={() => this.refreshTree()}
                    >
                      批量操作
                      <DownOutlined />
                    </Button>
                  </a>
                </Dropdown>
              </Col>
            )
          }
          <Col span={4}>
            <BookModel category={treeList} refreshTree={() => this.refreshTree()} />
          </Col>
          <Col span={4}>
            <CategoryModel data={treeList} refreshTree={() => this.refreshTree()} />
          </Col>
          <Col span={4}>
            <Button
              type="default"
              style={{ width: '100%' }}
              onClick={() => this.refreshTree()}
            >刷新</Button>
          </Col>
          <Col span={4}>
            <Button
              type="default"
              style={{ width: '100%' }}
              onClick={() => this.importFile()}
              loading={loading}
            >导入</Button>
          </Col>
          <Col span={4}>
            <Button
              type="default"
              style={{ width: '100%' }}
              onClick={() => this.addBook()}
            >导出</Button>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: 16 }}>
          <Col span={24}>
            <Tree tree={treeList} data={bookData} onCheck={(...args) => onCheck(...args)} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default Book;
